import {common_utils} from "../common/common_utils";
import {slots_tool} from "./slots_tool";

function game_5008()
{

}

game_5008.odd_map  = {
  "W":[0,0,50,250,500],
  "P5":[0,0,50,250,500],
  "P4":[0,0,40,200,400],
  "P3":[0,0,30,150,300],
  "P2":[0,0,25,125,250],
  "P1":[0,0,20,100,200],
  "A":[0,0,15,80,150],
  "K":[0,0,10,60,100],
  "Q":[0,0,10,60,100],
  "J":[0,0,5,50,80],
};
game_5008.mul_array  = [

];

game_5008.mul = 50

game_5008.readDataValue = function(this1,data) {
  this1.hasextra = true
  this1.hasfree = true
  this1.hasbonuswin = false
  this1.mapList = []
  console.log("game_5008.readDataValue")

  var rows = 3
  this1.isfree = common_utils.isFreeTip(data)
  var mapJson = JSON.parse(data.detail.mapData)
  this1.scatterwin = data.detail.winFreeGameTimes
  this1.ext = mapJson.exBet;
  this1.extra = mapJson.exBet?'是':'否';;
  common_utils.readDataValue(this1, data);
  this1.mapListDetail = [];
  this1.mapIndex = []
  for (var key = 0; key < mapJson.datas.length; key++) {
    var mapTmp = []
    let mapData = mapJson.datas[key];
    for (var j = 0; j < rows; j++) {
      for (var i = 0; i < 5; i++) {
        mapTmp.push(mapData.finalMap[i][j])
      }
    }
    this1.mapList.push(mapTmp)
    let mapWinIndex = {};
    var mapIndexTmp = []
    for (var index = 0; index < mapData.winList.length; index++)
    {
      var line = true;
      let win_data = mapData.winList[index]
      for (var subIndex = 0; subIndex < 5; subIndex++) {
        var showindex = win_data.l[subIndex] * 5 + subIndex;
        var item = mapTmp[showindex];
        if ((item != win_data.s) && (item != "W")) {
          line = false
        }
        if (line) {
          mapIndexTmp.push(showindex)
        }
      }
      slots_tool.read_win_data(mapWinIndex,win_data)
    }
    this1.mapListDetail.push(mapWinIndex)
    this1.mapIndex.push(mapIndexTmp)
  }

  let winValueList = [];
  slots_tool.setWinValue(winValueList,this1.mapListDetail,game_5008.odd_map,0);
  this1.winValueTotal = slots_tool.TotalValueByData(winValueList,data,game_5008.mul,this1.ext );

  this1.$nextTick(() => {
    this1.$nextTick(() => {
      this1.$nextTick(() => {
        this1.clearLines();
        setTimeout(() => {
          this1.clearLines();
          for (let key = 0; key < mapJson.datas.length; key++) {
            for (let index = 0; index < mapJson.datas[key].winList.length; index++) {
              for (let subIndex = 0; subIndex < 4; subIndex++) {
                let fromIndex = mapJson.datas[key].winList[index].l[subIndex] * 5 + subIndex;
                let toIndex = mapJson.datas[key].winList[index].l[subIndex + 1] * 5 + subIndex + 1;
                //this1.drawLines("m_" + key + "_" + fromindex, "m_" + key + "_" + toindex, index)
                // slots_tool.drawLines("m_s"  + key + "_" + fromindex, "m_s"  + key + "_" + toindex, index)
                slots_tool.drawLines(slots_tool.setMapsLineIdName("s",key,fromIndex), slots_tool.setMapsLineIdName("s",key,toIndex), index)
              }
            }
          }
        }, 1000);
      })
    })
  })
}
export {
  game_5008
};




// WEBPACK FOOTER //
// ./src/components/slots/game_5008.js